import React from "react";
import { Chip } from "@mui/material";

const STATUS_BADGE_COLOR = {
  pending: "warning",
  auto_resolved: "info",
  resolved: "success",
  reviewed: "info",
  rejected: "error",
};

const formatStatusLabel = (value) => {
  if (!value || typeof value !== "string") return value || "-";
  return value
    .split("_")
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");
};

const MissingStatusChip = ({ status }) => (
  <Chip
    size="small"
    label={formatStatusLabel(status)}
    color={STATUS_BADGE_COLOR[status] || "default"}
  />
);

export default MissingStatusChip;
